import React, {Component} from 'react'
import PropTypes from 'prop-types'
import UserInfoBox from '../UserInfoBox/UserInfoBox'

import AdminLogo from '../../../assets/Oggetto-vettoriale-avanzato.png'
import moment from 'moment'

import Threesome from '../../../assets/triangolo.png'

const TextUser = (props) => <div className={props.bold ? 'text-bold-user' : 'text-regular-user'}>{props.children}</div>

export default class UserAreaProfile extends Component {

  constructor (props) {
    super(props)
  }

  render () {
    let birthDate = moment(this.props.user.birthDate)
    return (<div className="row">
      <div className="col-md-7">
        {this.props.user && <div className="panel panel-default panel-border-login">
          <h2 className="login-title">
            {this.props.user.firstName.toUpperCase() + ' ' + this.props.user.lastName.toUpperCase()}
          </h2>
          <div className="panel-body">
            <div className="col-md-3"><img className="user-admin-logo" src={AdminLogo} /></div>
            <div className="col-md-9">
              <div className="user-details-card">
                <div className="row">
                  {this.props.user.fiscalCode && <TextUser>CODICE FISCALE</TextUser>}
                  {this.props.user.fiscalCode && <TextUser bold>{this.props.user.fiscalCode}</TextUser>}
                  {this.props.user.phone && <div className="text-regular-user">TELEFONO</div>}
                  {this.props.user.phone && <div className="text-bold-user">{this.props.user.phone}</div>}
                  {this.props.user.email && <div className="text-regular-user">E-MAIL</div>}
                  {this.props.user.email && <div className="text-bold-user">{this.props.user.email}</div>}
                  {this.props.user.birthDate && <div className="text-regular-user">DATA DI NASCITA </div>}
                  {this.props.user.birthDate && <div className="text-bold-user">{birthDate.format('L')}</div>}
                  {this.props.user.birthPlace && <div className="text-regular-user">LUOGO DI NASCITA</div>}
                  {this.props.user.birthPlace && <div className="text-bold-user">{this.props.user.birthPlace}</div>}
                  {this.props.user.sex && <div className="text-regular-user">SESSO </div>}
                  {this.props.user.sex && <div className="text-bold-user">{this.props.user.sex}</div>}
                  {(this.props.user.residenceAddress && this.props.user.residenceCivicNumber) && <div className="text-regular-user">INDIRIZZO DI RESIDENZA</div>}
                  {(this.props.user.residenceAddress && this.props.user.residenceCivicNumber) && <div className="text-bold-user"> {this.props.user.residenceAddress + ', ' + this.props.user.residenceCivicNumber}</div>}
                  {(this.props.user.workAddress && this.props.user.workCivicNumber && this.props.user.workCity && this.props.user.workCap) && <div className="text-regular-user">INDIRIZZO DI LAVORO </div>}
                  {(this.props.user.workAddress && this.props.user.workCivicNumber && this.props.user.workCity && this.props.user.workCap) && <div className="text-bold-user">{this.props.user.workAddress + ', ' + this.props.user.workCivicNumber + ', ' + this.props.user.workCity + ', ' + this.props.user.workCap}</div>}
                  {(this.props.user.companyName && this.props.user.companyLegalAddress) && <div className="text-regular-user">AZIENDA </div>}
                  {(this.props.user.companyName && this.props.user.companyLegalAddress) && <div className="text-bold-user">{this.props.user.companyName + ', ' + this.props.user.companyLegalAddress}</div>}
                  {this.props.user.vatNumber && <div className="text-regular-user">PARTITA IVA </div>}
                  {this.props.user.vatNumber && <div className="text-bold-user">{this.props.user.vatNumber}</div>}
                </div>
              </div>
            </div>
          </div>
          {(this.props.user.categories && this.props.user.categories.length > 0) && <div>
            <div className="row">
              <div className="col-md-8 col-md-offset-3">
                <div className="title-user-categories">
                  <strong style={{fontSize: 13}}>LA TUA CATEGORIA UTENTE E'</strong>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-md-offset-3">
                {this.props.user.categories.map(item => <div className="user-card-btn" key={item.id}>
                  <div className="user-btn-personalization1">
                    <span><strong>{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</strong></span>
                  </div>
                  <div className="user-btn-personalization2">
                    <span><strong>{item.description.charAt(0).toUpperCase() + item.description.slice(1)}</strong></span>
                  </div>
                </div>)}
              </div>
            </div>
          </div>}
        </div>}
      </div>

      <div className="col-md-4 col-md-offset-1 col-information-user hidden-xs hidden-sm">
        <div className="information-container">
          <div style={{marginLeft: 30}}>
            <div style={{marginTop: 15, marginBottom: 10}}>
              <TextUser bold>UTENTE</TextUser>
              <TextUser>
                <span className="threesom-span">
                  <img src={Threesome} />
                </span>
                Questi sono i tuoi dati di registrazione e la categoria a cui è associato il tuo profilo utente
              </TextUser>
            </div>
          </div>
        </div>
      </div>

    </div>)
  }
}

UserAreaProfile.defaultProps = {}

UserAreaProfile.propTypes = {}



// WEBPACK FOOTER //
// ./src/containers/UserArea/Profile/UserAreaProfile.js